export interface ProjectAreaResultMetadata {
	projectArea?: unknown;
	sheetNumber?: unknown;
	vectorFileName?: unknown;
}

const hasOwn = (value: Record<string, unknown>, key: string) =>
	Object.prototype.hasOwnProperty.call(value, key);

export const pickProjectAreaResultMetadata = (value: unknown): ProjectAreaResultMetadata => {
	const metadata: ProjectAreaResultMetadata = {};
	if (value == null || typeof value !== 'object') return metadata;
	const source = value as { [key: string]: unknown };

	if (hasOwn(source, 'projectArea')) metadata.projectArea = source.projectArea;
	if (hasOwn(source, 'sheetNumber')) metadata.sheetNumber = source.sheetNumber;
	if (hasOwn(source, 'vectorFileName')) metadata.vectorFileName = source.vectorFileName;

	return metadata;
};
